export const CACHE_CONTROL_TOKEN = 'cacheControl';

export const NOT_FOUND_PAGE_CACHE_CONTROL = 'no-cache, max-age=60';
export const PREVIEW_PAGE_CACHE_CONTROL = 'no-cache, max-age=0';
